import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {ApiModulesService} from 'src/app/api-modules.service';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'app-user-add',
    templateUrl: './user-add.component.html',
    styleUrls: ['./user-add.component.scss']
})
export class UserAddComponent implements OnInit {

    username = [];
    mobilenumber = [];
    status = [];
    blocked_message = [];
    blocked_add_channel = [];
    public addUserForm: FormGroup;
    @Output() visibleParentPageUser: EventEmitter<any> = new EventEmitter<any>();

  
    constructor(private apiModulesService: ApiModulesService, private formBuilder: FormBuilder, private route: ActivatedRoute) {
        this.createUserForm();
    }

    createUserForm() {
        this.addUserForm = this.formBuilder.group({
            username: [''],
            mobilenumber: [''],
            status: [''],
            blocked_message: [''],
            blocked_add_channel: [''],
        });
    }

    public CreateTelegramUser() {
        const params: any = {};
        console.log(this.addUserForm.value.username);
        // params.id = this.AddUser.value.id;
        params.username = this.addUserForm.value.username;
        params.mobilenumber = this.addUserForm.value.mobilenumber;
        params.status = this.addUserForm.value.status;
        params.blocked_message = this.addUserForm.value.blocked_message;
        params.blocked_add_channel = this.addUserForm.value.blocked_add_channel;
       // params.api_id = this.addUserForm.value.api_id;
        // params.api_hash = this.addUserForm.value.api_hash;

        // params.id = this.id;
        console.log('after');
        console.log(this.addUserForm);
        this.apiModulesService.add(params, 'telegram/user/add').subscribe((data) => {
            this.addUserForm = data;
            console.log(this.addUserForm);
            this.moveToMainPage();
        });
    }

    ngOnInit() {
    }
    public moveToMainPage() {
        this.visibleParentPageUser.emit(true);
    }
}
